import { useUpdateEffect } from 'react-use';

import { AnalyticalExaminationType } from '@dreryk/drerykweb-medical-dictionaries-api';

import { useFormController } from '@dreryk/react-common';
import { Autosuggest, FormLabel } from '@dreryk/react-components';

import { analyticalExaminationTranslationKeys, referralTranslationKeys } from '../../../translations';

import { analyticalExaminationTypeSearchCreator } from './AnalyticalExaminationTypeAutosuggest.hooks';

type AnalyticalExaminationTypeAutosuggestProps = {
   readonly addAnalyticalExaminationType: (analyticalExaminationType: AnalyticalExaminationType) => void;
   readonly invalid?: boolean;
   readonly validateSelector: () => void;
};
type AnalyticalExaminationTypeFormBean = {
   analyticalExaminationType: AnalyticalExaminationType[] | null;
};

const INITIAL_VALUES: AnalyticalExaminationTypeFormBean = {
   analyticalExaminationType: null,
};

const labelExtractor = (item: AnalyticalExaminationType): string => item.name;

const itemRenderer = (analyticalExaminationType: AnalyticalExaminationType): JSX.Element => (
   <div>{`${analyticalExaminationType.name}`}</div>
);

export const AnalyticalExaminationTypeAutosuggest = (props: AnalyticalExaminationTypeAutosuggestProps): JSX.Element => {
   const { register, trigger, setValue } = useFormController<AnalyticalExaminationTypeFormBean>(INITIAL_VALUES);

   useUpdateEffect(() => {
      trigger();
   }, [props.invalid]);

   const onAnalyticalExaminationTypeSelection = (examination: AnalyticalExaminationType | null): void => {
      if (examination) {
         props.addAnalyticalExaminationType(examination);
         setTimeout(() => {
            setValue('analyticalExaminationType', null);
         }, 0);
      }
   };

   return (
      <Autosuggest<AnalyticalExaminationType>
         label={
            <FormLabel
               label={referralTranslationKeys.analyticalExamination.analyticalExaminations}
               required
               testId='diagnosis'
            />
         }
         placeholder={analyticalExaminationTranslationKeys.searchAnalyticalExaminations}
         minChars={2}
         labelExtractor={labelExtractor}
         itemRenderer={itemRenderer}
         searchCreator={analyticalExaminationTypeSearchCreator}
         onSelectionChange={onAnalyticalExaminationTypeSelection}
         keyProperty={'id'}
         controller={register('analyticalExaminationType', {
            validate: () => {
               props.validateSelector();
               if (props.invalid) {
                  return 'common:validation.required';
               }
               return undefined;
            },
         })}
         testId={'analyticalExamination'}
      />
   );
};
